<template>
  <html>
  <body style="position: relative;background: #fff">
  <!-- <div class="nbanner"> <img src="@/assets/styles/images/ny5.png" alt=""> </div> -->
  <!--主体开始-->
  <div class="nding">
    <div>
      <p>当前位置：</p>
      <a href="/home">首页</a>&gt; <a href="/information/hyzx">{{info.typename}}</a>&gt; <a :href="'/information/list?tid='+info.tid">{{info.childtypename}}</a>&gt; <a href="">正文</a> </div>
  </div>
  <section class="section ncontainer5" v-loading="loading">
    <div class="neit">
      <div class="new_detail">
        <div class="zuo">
          <h2 class="h2_title">{{ info.title }}</h2>
          <div class="fu">
            <p>发布时间：{{ $util.timeStampTurnTime(info.createtime) }}</p>
            <p>来源：{{info.source}}</p>
            <p>编辑：{{info.author}}</p>
            <p>阅读：{{info.click_count}}</p>
            <p v-if="info.typenumber == '10002' && !$util.isEmpty(info.start_date) && !$util.isEmpty(info.end_date)">展会时间：{{ $util.timeStampTurnTime(info.start_date, 'YYYY-MM-DD') }}   -   {{ $util.timeStampTurnTime(info.end_date, 'YYYY-MM-DD') }}</p>
            <a class="shoucang">
              <div class="img1" v-if="!isshow" @click="collection(1)"><img style="width:15px;height:15px" src="@/assets/styles/images/xq4.png" alt=""><span>收藏</span></div>
              <div class="img1" v-if="isshow" @click="collection(0)"><img style="width:15px;height:15px" src="@/assets/styles/images/xq44.png" alt=""><span>已收藏</span></div>
            </a>
          </div>
          <div class="dao"> <em>【导读】</em>
            <p>{{info.subtitle}}</p>
          </div>
          <div class="xia" v-html="info.content"></div>
          <ul>
            <li v-if="!$util.isEmpty(info.prev)"><a :href="'/information/details?id='+info.prev.id"> <span>上一篇</span> {{info.prev.title}}</a></li>
            <li v-if="!$util.isEmpty(info.next)"><a :href="'/information/details?id='+info.next.id"> <span>下一篇</span> {{info.next.title}} </a></li>
          </ul>
        </div>
        <div class="you">
          <h2><span>推荐新闻</span></h2>
          <ul>
            <li v-for="item in newslist" :key="item.id">
              <a :href="'/information/details?id='+item.id">
                <div class="tu"> <img :src="$util.img(item.image)" alt=""> </div>
                <p>{{item.title}}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  </body>
  </html>
</template>

<script>

import { informationDetail } from '@/api/information/information';
import { informationList } from '@/api/information/information';
import { information_Collection } from '@/api/information/information';
import { getToken } from "@/utils/auth.js";

export default {
  name: '',
  components: {},
  data: () => {
		return {
			info: {},
      id:'',
      newslist:[],
			loading: true,
      isshow: false,
      token:''
		};
	},
  created() {
    this.token = getToken();
    this.id = this.$route.query.id;
		this.getDetail();
    this.getList();
	},
  watch: {
		$route(curr) {
			this.id = this.$route.query.id;
			this.getDetail();
      this.getList();
		}
	},
	methods: {
		getDetail() {
			informationDetail({
				id: this.id
			})
				.then(res => {
					if (res.data) {
						this.info = res.data;
            this.isshow = this.info.iscollection;

            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = this.info.title + ' - ' + title[1];

						this.loading = false;
					}
				})
				.catch(err => {
					this.loading = false;
					this.$message.error(err.message);
				});
		},
    getList() {
			informationList({
				recommend: 'true',
        isImg:true,
        limit: 6
			})
				.then(res => {
					if (res.data) {
						this.newslist = res.data;
					} else {
						
					}
				})
				.catch(err => {

					this.$message.error(err.message);
				});
    },
    collection(type) {
        if(util.isEmpty(this.token))
                {
                    location.href = '/login?redirect=' + this.$route.fullPath;
                    return;
                }
                var params = {};
                var msg = "收藏成功！";
                if(type == 1) {
                    this.isshow = true;
                    params = {id:this.id};
                }
                else {
                    this.isshow = false;
                    params = {id:this.id, iscancel:1};
                    msg = "取消成功！"
                }
                information_Collection(params).then(res => {
                    if(res.code == 0) {
                        this.$message.success(msg);
                    }
                    else {
                        this.$message.warning(res.message);
                    }
                })
            }
	}

};
</script>
<style>
	.h2_title{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-items: center;
		justify-content: center;
	}
</style>